import React, { useState } from "react";
import {
  MimaButton,
  MimaDropdown,
  MimaInput,
  MimaText,
  MimaTextArea,
  MimaToastUtil,
  Modal,
} from "../../components";
import { Formik } from "formik";
import * as yup from "yup";
import { WalletController } from "../../controllers";
import constant from "../../utils/constant";

const BlockFundsModal = ({
  closeModal,
  selectedBusinessWallet,
  selectedBusiness,
}) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = () => {
    return yup.object({
      id: yup.string().required("Wallet Currency is required"),
      reason: yup.string().required("Reason for blocking funds is required"),
      amount: yup
        .number()
        .required("Amount to be blocked is required")
        .min(0, "Amount cannot be negative"),
    });
  };

  const onSubmit = async (values) => {
    console.log("values", values);
    setLoading(true);

    const { status, errorMessage } = await WalletController.blockFunds(values);
    setLoading(false);
    if (status === constant.Success) {
      MimaToastUtil.success({
        message: `Amount blocked successfully`,
      });

      return closeModal();
    }

    return MimaToastUtil.error({
      message: errorMessage,
    });
  };

  return (
    <Modal closeModal={closeModal}>
      <MimaText
        variant="subtitle"
        align="center"
        mb={3}
        width={40}
      >{`Block Funds in ${selectedBusiness?.tradingName}'s Wallet`}</MimaText>

      <MimaText variant="small" mb={3} width={38} align="center">
        Select a wallet currency and add the amount to block
      </MimaText>
      <Formik
        initialValues={{
          id: "",
          reason: "",
          amount: 0,
        }}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({
          handleChange,
          handleBlur,
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
        }) => (
          <div>
            <MimaDropdown
              labelTitle="Select Wallet"
              name="currencyCode"
              value={values.id}
              placeholder="Select wallet"
              id="id"
              currentValue={values.id}
              onChange={(data) => {
                setFieldValue("id", data.key);
              }}
              data={selectedBusinessWallet?.map((x) => {
                return {
                  value: `${x.currencyCode} wallet`,
                  key: x._id,
                };
              })}
              touched={touched.id}
              error={errors.id}
            />

            <MimaInput
              labelTitle="Amount to block"
              name="amount"
              placeholder="Amount"
              value={values.amount}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.amount}
              touched={touched.amount}
              type="number"
            />

            <MimaTextArea
              labelTitle="Reason"
              name="reason"
              placeholder="Reason for blocking"
              value={values.reason}
              onChange={handleChange}
              onBlur={handleBlur}
              error={errors.reason}
              touched={touched.reason}
            />

            <MimaButton
              title="Continue"
              onClick={handleSubmit}
              type="submit"
              width={38}
              loading={loading}
            />
          </div>
        )}
      </Formik>
    </Modal>
  );
};

export default BlockFundsModal;
